<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <base-button :to="{ name: 'penjualan.topup.deposit-sc.tambah' }"
          >Topup Deposit SC</base-button
        >
      </div>
      <div>
        <datatable
          :columns="columns"
          :data="balanceTrxes.data"
          :scroll-x="false"
          :total="balanceTrxes.meta.page.total"
          :perPage="balanceTrxes.meta.page.perPage"
          :currentPage="balanceTrxes.meta.page.currentPage"
          @pagechanged="onPageChanged"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="(balanceTrx, index) in balanceTrxes.data"
              :key="balanceTrx.id"
              :class="[
                classes.tr,
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                'bg-white hover:bg-green-100',
              ]"
            >
              <td :class="[classes.td]">
                <span class="font-bold text-gray-900">{{
                  getSingleIncluded(
                    balanceTrxes,
                    balanceTrx.relationships.office.data.id
                  ).attributes.code
                }}</span>
              </td>
              <td :class="classes.td">
                {{ balanceTrx.attributes.createdAt | formatDate }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ balanceTrx.attributes.deposit_multiplier | toCurrency }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ balanceTrx.attributes.deposit_amount | toCurrency }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ balanceTrx.attributes.deposit_multiplier * balanceTrx.attributes.deposit_amount | toCurrency }}
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge
                  v-if="balanceTrx.attributes.is_approved"
                  color="green"
                >
                  Selesai
                </base-badge>
                <base-badge
                  v-else-if="balanceTrx.attributes.is_valid"
                  color="yellow"
                >
                  Valid Kasir
                </base-badge>
                <base-badge
                  v-else
                  color="red"
                  class="cursor-pointer"
                  @click="onOpenValidate(balanceTrx)"
                >
                  Draft
                </base-badge>
              </td>
              <td :class="classes.td">
                {{ balanceTrx.attributes.description }}
              </td>
              <td :class="[classes.td, 'text-center']">
                <div v-if="!balanceTrx.attributes.is_valid" class="flex justify-center items-center">
                  <router-link :to="{ name: 'penjualan.topup.deposit-sc.edit', params: { id: balanceTrx.id } }" title="Edit" class="text-green-600 cursor-pointer mr-2">
                    <Icon icon="heroicons:pencil-square-solid" class="w-4 h-4" />
                  </router-link>
                  <button title="Hapus" class="text-red-600 cursor-pointer" @click="onOpenDelete(balanceTrx)">
                    <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </div>
    <base-confirm
      icon-type="badge"
      type="success"
      title="Konfirmasi Topup Saldo Deposit SC"
      message="Tekan tombol konfirmasi untuk mengonfirmasi topup saldo deposit SC"
      confirm-text="Konfirmasi"
      :visible="confirmValidate.visible"
      @close="confirmValidate.visible = false"
      @confirmed="onValidate"
    />
    <base-confirm
      icon-type="badge"
      type="success"
      title="Konfirmasi Hapus Saldo Deposit SC"
      message="Tekan tombol hapus untuk mengonfirmasi topup saldo deposit SC"
      confirm-text="Konfirmasi"
      :visible="confirmDelete.visible"
      @close="confirmDelete.visible = false"
      @confirmed="onDelete"
    />
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseConfirm,
  },
  data() {
    return {
      balanceTrxes: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      loadingBalanceTrxes: false,
      loadingValidateBalanceTrx: false,
      loadingDeleteBalanceTrx: false,
      confirmValidate: {
        visible: false,
        id: null,
      },
      confirmDelete: {
        visible: false,
        id: null,
      },
    };
  },
  computed: {
    columns() {
      return [
        { id: 'office_code', name: 'Kode Stockist Center' },
        { id: 'createdAt', name: 'Tanggal Top Up' },
        { id: 'multiplier', name: 'Nilai Pengali', theadClass: 'text-right' },
        { id: 'amount', name: 'Nilai Deposit', theadClass: 'text-right' },
        { id: 'final_amount', name: 'Jumlah Deposit', theadClass: 'text-right' },
        { id: 'status', name: 'Status', theadClass: 'text-center' },
        { id: 'description', name: 'Keterangan' },
        { id: 'action', name: 'Aksi', theadClass: 'text-center' },
      ];
    },
    loading() {
      return this.loadingBalanceTrxes || this.loadingValidateBalanceTrx || this.loadingDeleteBalanceTrx;
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadBalanceTrxes(params = {}) {
      this.loadingBalanceTrxes = true;

      const [res, error] = await this.request('/api/v1/balance-trxes', {
        params: {
          'page[size]': 5,
          'sort': '-id',
          'filter[trx_type]': 'topup_deposit_balance',
          'filter[balance_type]': 'deposit_balance',
          include: 'office',
          'fields[balance-trxes]':
            'office,createdAt,deposit_multiplier,deposit_amount,is_valid,is_approved,description',
          'fields[offices]': 'code',
          ...params,
        },
      });

      if (!error) {
        this.balanceTrxes = res;
      }

      this.loadingBalanceTrxes = false;
    },
    onPageChanged(page) {
      this.loadBalanceTrxes({
        'page[number]': page,
      });
    },
    onOpenValidate(balanceTrx) {
      this.confirmValidate.id = balanceTrx.id;
      this.confirmValidate.visible = true;
    },
    onOpenDelete(balanceTrx) {
      this.confirmDelete.id = balanceTrx.id;
      this.confirmDelete.visible = true;
    },
    async onValidate() {
      this.loadingValidateBalanceTrx = true;

      const [, error] = await this.request(
        `/api/v1/balance-trxes/${this.confirmValidate.id}/-actions/validate-topup`,
        {
          method: 'patch',
        }
      );

      if (error) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(error),
        });
      } else {
        this.confirmValidate.visible = false;

        this.loadBalanceTrxes();
      }

      this.loadingValidateBalanceTrx = false;
    },
    async onDelete() {
      this.loadingDeleteBalanceTrx = true;

      const [, error] = await this.request(
        `/api/v1/balance-trxes/${this.confirmDelete.id}`,
        {
          method: 'delete',
        }
      );

      if (error) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(error),
        });
      } else {
        this.confirmDelete.visible = false;

        this.loadBalanceTrxes();
      }

      this.loadingDeleteBalanceTrx = false;
    
    }
  },
  created() {
    this.loadBalanceTrxes();
  },
};
</script>
